// Comportamenti comuni del layout 2026 (nav, header, footer).
// Da convertire: public/proposta/assets/js/main.js
// Stato avanzamento: vedi docs/2026-layout-CHANGELOG.md

import AOS from 'aos';
import 'aos/dist/aos.css';

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    AOS.init({ duration: 750, easing: 'ease-out-quart', once: true, offset: 60 });
}

(function () {
    var nav = document.getElementById('siteNav');
    if (!nav) {
        return;
    }

    /* ── Nav: scroll-aware light/dark ── */
    var lightSecs = document.querySelectorAll('.section--light');
    var NAV_H     = 64;

    function updateNav() {
        var isLight = false;
        lightSecs.forEach(function (sec) {
            var r = sec.getBoundingClientRect();
            if (r.top <= NAV_H && r.bottom > NAV_H) isLight = true;
        });
        nav.classList.toggle('nav--light', isLight);
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    /* ── Nav: keyboard dropdown (desktop only) ── */
    document.querySelectorAll('.nav-item').forEach(function (item) {
        var btn  = item.querySelector('button.nav-link');
        var drop = item.querySelector('.nav-dropdown');
        if (!btn || !drop) return;
        btn.addEventListener('click', function () {
            if (window.innerWidth < 961) return;
            var open = item.classList.toggle('nav-item--open');
            btn.setAttribute('aria-expanded', open);
        });
        document.addEventListener('click', function (e) {
            if (!item.contains(e.target)) {
                item.classList.remove('nav-item--open');
                btn.setAttribute('aria-expanded', 'false');
            }
        });
    });

    /* ── Nav: mobile hamburger ── */
    var hamburger = document.getElementById('navHamburger');
    var navMenu   = document.getElementById('navMenu');

    hamburger.addEventListener('click', function () {
        var open = navMenu.classList.toggle('nav-menu--open');
        hamburger.classList.toggle('nav-hamburger--open', open);
        hamburger.setAttribute('aria-expanded', open);
        navMenu.setAttribute('aria-hidden', !open);
        document.body.style.overflow = open ? 'hidden' : '';
    });

    /* Accordion dropdowns on mobile */
    navMenu.querySelectorAll('button.nav-link[aria-haspopup]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            if (window.innerWidth >= 961) return;
            var item = btn.closest('.nav-item');
            var open = item.classList.toggle('nav-item--open');
            btn.setAttribute('aria-expanded', open);
            navMenu.querySelectorAll('.nav-item--open').forEach(function (el) {
                if (el !== item) {
                    el.classList.remove('nav-item--open');
                    var other = el.querySelector('button.nav-link[aria-haspopup]');
                    if (other) other.setAttribute('aria-expanded', 'false');
                }
            });
        });
    });

    /* Close nav when clicking a link inside it on mobile */
    navMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () {
            if (window.innerWidth >= 961) return;
            navMenu.classList.remove('nav-menu--open');
            hamburger.classList.remove('nav-hamburger--open');
            hamburger.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });
    });
})();

/* ── Title word-compose ── */
(function () {
    var STAGGER = 110;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function splitWords(el) {
        var inners = [];
        var nodes = Array.from(el.childNodes);
        el.innerHTML = '';

        function process(node, target) {
            if (node.nodeType === 3) {
                node.textContent.split(/(\s+)/).forEach(function (part) {
                    if (/^\s*$/.test(part)) {
                        target.appendChild(document.createTextNode(part));
                    } else {
                        var w = document.createElement('span');
                        w.className = 'title-word';
                        var i = document.createElement('span');
                        i.className = 'title-word-inner';
                        i.textContent = part;
                        w.appendChild(i);
                        target.appendChild(w);
                        inners.push(i);
                    }
                });
            } else if (node.tagName === 'EM') {
                var em = document.createElement('em');
                Array.from(node.childNodes).forEach(function (n) { process(n, em); });
                target.appendChild(em);
            } else if (node.tagName === 'BR') {
                target.appendChild(document.createElement('br'));
            } else {
                target.appendChild(node.cloneNode(true));
            }
        }

        nodes.forEach(function (n) { process(n, el); });
        return inners;
    }

    function reveal(inners, baseDelay) {
        inners.forEach(function (inner, i) {
            inner.style.setProperty('--wd', (baseDelay + i * STAGGER) + 'ms');
            requestAnimationFrame(function () {
                requestAnimationFrame(function () { inner.classList.add('wrd-visible'); });
            });
        });
    }

    if (reducedMotion) return;

    function findEyebrow(titleEl) {
        var parent = titleEl.parentElement;
        var eb = parent && parent.querySelector(':scope > .eyebrow');
        if (!eb && parent) {
            var gp = parent.parentElement;
            eb = gp && gp.querySelector('.eyebrow');
        }
        return eb || null;
    }

    var heroTitle = document.getElementById('hero-title');
    var scrollTitles = ['cosa-title', 'numeri-title', 'come-title', 'cta-title',
                        'sub-title', 'shift-title', 'flow-title', 'aree-title', 'faq-title',
                        // Chi siamo: le 5 sezioni editoriali (cta-title è già coperto sopra)
                        'origini-title', 'sfida-title', 'prodotti-title', 'tavola-title',
                        'condividere-title']
        .map(function (id) { return document.getElementById(id); })
        .filter(Boolean);

    var heroWords = heroTitle ? splitWords(heroTitle) : [];

    var scrollWords = scrollTitles.map(function (el) {
        var eyebrow = findEyebrow(el);
        if (eyebrow) {
            eyebrow.style.opacity = '0';
            eyebrow.style.transform = 'translateY(10px)';
            eyebrow.style.transition = 'opacity 0.45s ease-out, transform 0.55s cubic-bezier(0.16, 1, 0.3, 1)';
        }
        return { el: el, inners: splitWords(el), eyebrow: eyebrow };
    });

    if (heroWords.length) {
        setTimeout(function () { reveal(heroWords, 0); }, 150);
    }

    if (scrollWords.length) {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                io.unobserve(entry.target);
                var found = scrollWords.find(function (o) { return o.el === entry.target; });
                if (!found) return;
                if (found.eyebrow) {
                    requestAnimationFrame(function () {
                        found.eyebrow.style.opacity = '1';
                        found.eyebrow.style.transform = 'translateY(0)';
                    });
                }
                setTimeout(function () { reveal(found.inners, 0); }, 300);
            });
        }, { threshold: 0.4 });

        scrollWords.forEach(function (o) { io.observe(o.el); });
    }
})();

/* ── Timeline animation ── */
(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var viewport  = document.getElementById('tlViewport');
    var inner     = document.getElementById('tlInner');
    var lineGreen = document.getElementById('tlLineGreen');
    var bar       = document.getElementById('tlBar');
    var uffZone   = document.getElementById('tlUfficio');
    var heroVis   = document.querySelector('.hero-visual');

    if (!viewport || !inner) return;

    var SCROLL_PX_S = 46;
    var FADE_OUT_MS = 550;

    inner.style.cssText = 'opacity:0;transform:translateY(0);transition:none;will-change:transform,opacity;';

    var startY, endY, uffRelTop;

    document.fonts.ready.then(function () {
        requestAnimationFrame(function () {
            var vpH      = viewport.offsetHeight;
            var innerTop = inner.getBoundingClientRect().top;
            var allEv    = inner.querySelectorAll('.tl-event');
            var firstEl  = allEv[0];
            var firstR   = firstEl.getBoundingClientRect();
            var firstCtr = (firstR.top - innerTop) + firstR.height * 0.5;
            var lastEl   = allEv[allEv.length - 1];
            var lastR    = lastEl.getBoundingClientRect();
            var lastCtr  = (lastR.top - innerTop) + lastR.height * 0.5;
            var uffR     = uffZone.getBoundingClientRect();
            uffRelTop    = uffR.top - innerTop;
            endY         = vpH * 0.5 - lastCtr;
            startY       = vpH * 0.7 - firstCtr;

            inner.style.transform = 'translateY(' + startY + 'px)';
            inner.style.opacity   = '1';
            updateLine(startY);

            heroVis.style.cssText = 'opacity:0;transform:translateY(20px);transition:none;';
            requestAnimationFrame(function () {
                heroVis.style.transition = 'opacity 700ms ease-out, transform 700ms cubic-bezier(0.16,1,0.3,1)';
                heroVis.style.opacity    = '1';
                heroVis.style.transform  = 'translateY(0)';
                setTimeout(function () { heroVis.style.cssText = ''; startLoop(); }, 750);
            });
        });
    });

    function updateLine(y) {
        var vpH  = viewport.offsetHeight;
        var topPx = Math.max(0, Math.min(vpH, y + uffRelTop));
        lineGreen.style.top = topPx + 'px';
    }

    var barRaf = null;
    function startBar(ms) {
        if (barRaf) cancelAnimationFrame(barRaf);
        var elapsed = 0, lastTs = null;
        bar.style.cssText = 'transition:none;width:0%';
        (function tick(ts) {
            if (lastTs !== null && !paused) elapsed += ts - lastTs;
            lastTs = ts;
            var pct = Math.min((elapsed / ms) * 100, 100);
            bar.style.width = pct + '%';
            if (pct < 100) barRaf = requestAnimationFrame(tick);
        })(performance.now());
    }
    function stopBar() {
        if (barRaf) cancelAnimationFrame(barRaf);
        bar.style.cssText = 'transition:none;width:0%';
    }

    var scrollRafId = null;
    var paused = false;

    heroVis.addEventListener('mouseenter', function () { paused = true; });
    heroVis.addEventListener('mouseleave', function () { paused = false; });

    function doScroll(from, to) {
        return new Promise(function (res) {
            var pos = from, last = null;
            function tick(ts) {
                if (!last) last = ts;
                if (!paused) {
                    pos -= SCROLL_PX_S * ((ts - last) / 1000);
                    if (pos <= to) pos = to;
                    inner.style.transform = 'translateY(' + pos + 'px)';
                    updateLine(pos);
                }
                last = ts;
                if (pos > to) { scrollRafId = requestAnimationFrame(tick); }
                else          { scrollRafId = null; res(); }
            }
            scrollRafId = requestAnimationFrame(tick);
        });
    }

    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    async function runCycle() {
        var scrollMs = ((startY - endY) / SCROLL_PX_S) * 1000;
        startBar(scrollMs + FADE_OUT_MS);
        await doScroll(startY, endY);
        stopBar();
        inner.style.transition     = lineGreen.style.transition = 'opacity ' + FADE_OUT_MS + 'ms ease-out';
        inner.style.opacity        = lineGreen.style.opacity    = '0';
        doScroll(endY, endY - 600);
        await sleep(FADE_OUT_MS + 40);
        if (scrollRafId) { cancelAnimationFrame(scrollRafId); scrollRafId = null; }
        inner.style.transition     = lineGreen.style.transition = 'none';
        inner.style.transform      = 'translateY(' + startY + 'px)';
        inner.style.opacity        = lineGreen.style.opacity    = '1';
        updateLine(startY);
        await new Promise(function (r) { requestAnimationFrame(r); });
    }

    async function startLoop() { while (true) { await runCycle(); } }
})();

/* ── Numeri count-up ── */
(function () {
    var grid = document.querySelector('.numeri-grid');
    if (!grid || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var easeOutQuartNumeri = function (p) { return 1 - Math.pow(1 - p, 4); };

    function numeriCounter(renderFn, to, ms) {
        var t0 = null;
        (function tick(ts) {
            if (!t0) t0 = ts;
            var p = easeOutQuartNumeri(Math.min((ts - t0) / ms, 1));
            renderFn(Math.round(to * p));
            if (p < 1) requestAnimationFrame(tick);
        })(performance.now());
    }

    var numeriIo = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        numeriIo.disconnect();

        var c1 = grid.querySelector('.numeri-cell:nth-child(1) .numeri-value');
        if (c1) numeriCounter(function (v) { c1.textContent = v + 'k+'; }, 50, 1500);

        var c2 = grid.querySelector('.numeri-cell:nth-child(2) .numeri-value');
        if (c2) numeriCounter(function (v) { c2.textContent = v; }, 495, 1500);

        var c3 = grid.querySelector('.numeri-cell:nth-child(3) .numeri-value');
        if (c3) {
            var spanHTML = c3.querySelector('span') ? c3.querySelector('span').outerHTML : '';
            numeriCounter(function (v) { c3.innerHTML = '<em>' + v + spanHTML + '</em>'; }, 42, 1500);
        }
    }, { threshold: 0.4 });

    numeriIo.observe(grid);
})();

/* ── Testimonial carousel (mobile only — desktop shows all stacked) ── */
(function () {
    var INTERVAL = 7500;
    var FADE_MS  = 380;
    var carousel = document.querySelector('.testimonial-carousel');
    if (!carousel) return;
    var cards    = Array.from(carousel.querySelectorAll('.testimonial'));
    var dotsWrap = document.getElementById('testimonial-dots');
    var current  = 0;
    var timer    = null;
    var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var dots = [];
    if (cards.length > 1 && dotsWrap) {
        cards.forEach(function (_, i) {
            var btn = document.createElement('button');
            btn.className = 't-dot' + (i === 0 ? ' t-dot--active' : '');
            btn.setAttribute('aria-label', 'Testimonianza ' + (i + 1));
            btn.addEventListener('click', function () { goTo(i); resetTimer(); });
            dotsWrap.appendChild(btn);
            dots.push(btn);
        });
    }

    function goTo(index) {
        if (index === current) return;
        if (window.innerWidth >= 961) return;
        var prev = cards[current], next = cards[index];
        if (reduced) {
            prev.classList.remove('is-active');
            if (dots[current]) dots[current].classList.remove('t-dot--active');
            current = index;
            next.classList.add('is-active');
            if (dots[current]) dots[current].classList.add('t-dot--active');
            return;
        }
        prev.classList.add('is-fading');
        setTimeout(function () {
            prev.classList.remove('is-active', 'is-fading');
            if (dots[current]) dots[current].classList.remove('t-dot--active');
            current = index;
            next.classList.add('is-active');
            if (dots[current]) dots[current].classList.add('t-dot--active');
        }, FADE_MS);
    }

    var paused = false;
    function advance()    { goTo((current + 1) % cards.length); }
    function startTimer() { if (window.innerWidth >= 961) return; clearInterval(timer); timer = setInterval(advance, INTERVAL); }
    function stopTimer()  { clearInterval(timer); timer = null; }
    function resetTimer() { stopTimer(); if (!paused) startTimer(); }

    var prevBtn = document.getElementById('testimonialPrev');
    var nextBtn = document.getElementById('testimonialNext');
    if (prevBtn) prevBtn.addEventListener('click', function () {
        goTo((current - 1 + cards.length) % cards.length);
        resetTimer();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
        goTo((current + 1) % cards.length);
        resetTimer();
    });

    if (cards.length > 1) {
        startTimer();
        carousel.addEventListener('mouseenter', function () { paused = true;  stopTimer(); });
        carousel.addEventListener('mouseleave', function () { paused = false; startTimer(); });
    }
})();

/* ── Popup di notifica/errore: pulsante "chiudi" ──
   Porting vanilla (senza jQuery) di resources/js/public/theme.js righe 59-66.
   #info-msg è iniettato da core::public.master_2026 quando c'è un messaggio
   flash di sessione o errori di validazione dal form. */
(function () {
    var infoMsg = document.getElementById('info-msg');
    if (!infoMsg) return;
    document.querySelectorAll('.chiudi').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            infoMsg.style.display = 'none';
            var overlay = document.querySelector('.overlay-popup');
            if (overlay) overlay.style.display = 'none';
        });
    });
})();
